export const COMPANY = {
  name: "Schössow Dienstleistungen UG",
  brand: "Hausnotruf",
  street: "Neben dem Brand 10",
  zip: "44135",
  city: "Dortmund",
  phoneDisplay: "0231 39085116",
  phoneHref: "+4923139085116",
  email: "info@alarmanlagen.haus",
  whatsappHref: "4923139085116",
  whatsappMsg: "Hallo, ich interessiere mich für den Hausnotruf und hätte gerne eine Beratung.",
  googleReviewsUrl: "https://share.google/C0PFA3Q3ERD0kwhFI",
  domain: "https://hausnotruf.services",
};

// Regionen/Städte für lokale Sichtbarkeit (ohne eigene Unterseiten).
// Fokus Ruhrgebiet/NRW rund um Dortmund + deutschlandweit.
export const SERVICE_CITIES = [
  "Dortmund", "Bochum", "Essen", "Düsseldorf", "Köln", "Duisburg",
  "Wuppertal", "Gelsenkirchen", "Herne", "Hagen", "Hamm", "Witten",
  "Lünen", "Unna", "Castrop-Rauxel", "Schwerte", "Kamen", "Bergkamen",
  "Recklinghausen", "Bottrop", "Oberhausen", "Mülheim an der Ruhr",
  "Bonn", "Münster",
];

export const HERO_VIDEO = "https://customer-assets-lqy194kg.emergentagent.net/job_66c027b5-fc51-463c-a764-56eba14dc228/artifacts/qci4s2co_Hausnotruf.mp4";
export const HERO_POSTER = "https://images.pexels.com/photos/8088904/pexels-photo-8088904.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export const STEPS = [
  {
    n: "1",
    title: "Knopfdruck",
    text: "Im Notfall einfach den wasserdichten SOS-Funkbutton an Armband oder Kette drücken.",
    icon: "Hand",
  },
  {
    n: "2",
    title: "Alarm wird übermittelt",
    text: "Das Signal wird sofort und sicher an die Basisstation und die Notrufzentrale gesendet.",
    icon: "Radio",
  },
  {
    n: "3",
    title: "Sprechkontakt",
    text: "Über die Freisprecheinrichtung meldet sich die 24-Stunden-Notrufzentrale und klärt die Lage.",
    icon: "PhoneCall",
  },
  {
    n: "4",
    title: "Hilfe kommt",
    text: "Angehörige oder der Rettungsdienst werden umgehend informiert und Hilfe wird organisiert.",
    icon: "Ambulance",
  },
];

export const BENEFITS = [
  { icon: "Zap", title: "Schnelle Hilfe rund um die Uhr", text: "Mit nur einem Knopfdruck wird sofort Hilfe alarmiert – 24 Stunden am Tag, 365 Tage im Jahr." },
  { icon: "ShieldCheck", title: "Mehr Sicherheit im Alltag", text: "Für Sie und Ihre Angehörigen – ein beruhigendes Gefühl, jederzeit und überall im Haus." },
  { icon: "Feather", title: "Einfach & diskret", text: "Der leichte Funkbutton lässt sich als Anhänger oder am Handgelenk unauffällig tragen." },
  { icon: "BatteryCharging", title: "Lange Batterielaufzeit", text: "Zuverlässig über viele Monate – mit rechtzeitiger, automatischer Batteriewarnung." },
  { icon: "Droplets", title: "Wasserdicht & robust", text: "Auch unter der Dusche oder in der Küche einsatzbereit – dort, wo Stürze häufig passieren." },
  { icon: "Lock", title: "Datenschutz & Zuverlässigkeit", text: "Sichere Funübertragung nach deutschen Standards – vertraulich und geprüft." },
];

export const AUDIENCES = [
  {
    key: "senioren",
    label: "Senioren",
    title: "Senioren, die alleine wohnen",
    text: "Für ein selbstbestimmtes Leben in den eigenen vier Wänden – mit dem sicheren Gefühl, im Notfall nie allein zu sein.",
    points: ["Selbstständig bleiben zu Hause", "Hilfe auf Knopfdruck", "Kein kompliziertes Handy nötig"],
    img: "https://images.pexels.com/photos/8088904/pexels-photo-8088904.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "angehoerige",
    label: "Angehörige",
    title: "Angehörige & Familie",
    text: "Sicherheit für Ihre Liebsten – auch dann, wenn Sie nicht vor Ort sein können. Sie werden im Notfall sofort informiert.",
    points: ["Sofortige Benachrichtigung", "Weniger Sorgen im Alltag", "Beratung für die ganze Familie"],
    img: "https://images.pexels.com/photos/18509799/pexels-photo-18509799.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "pflege",
    label: "Pflege & Sturzrisiko",
    title: "Sturz- & Notfallsituationen",
    text: "Ideale Ergänzung zur häuslichen Pflege. Schnelle Alarmierung kann in kritischen Situationen Leben retten.",
    points: ["Schnelle Reaktion bei Stürzen", "Ergänzung zur Pflege zu Hause", "Entlastung für Pflegende"],
    img: "https://images.unsplash.com/photo-1571666522201-5b39e6d0cd29?crop=entropy&cs=srgb&fm=jpg&q=85&w=940&h=650&fit=crop",
  },
];

export const TRUST_PILLARS = [
  { icon: "Headphones", title: "24h Notrufzentrale", text: "Rund um die Uhr erreichbar" },
  { icon: "UserCheck", title: "Fachkundige Beratung", text: "Persönlich & unverbindlich" },
  { icon: "Wrench", title: "Professionelle Installation", text: "Wir richten alles für Sie ein" },
  { icon: "BadgeCheck", title: "Zuverlässiger Service", text: "Aus Dortmund, deutschlandweit" },
];

export const CALLBACK_TIMES = [
  "Vormittags (9–12 Uhr)",
  "Mittags (12–15 Uhr)",
  "Nachmittags (15–18 Uhr)",
  "Abends (18–20 Uhr)",
  "Schnellstmöglich",
];

// Google reviews: populated with real data.
// GOOGLE_RATING { value, count } and GOOGLE_REVIEWS [{ author, rating, date, text, initial }]
export const GOOGLE_RATING = { value: 4.8, count: 2811 };
export const GOOGLE_REVIEWS = [];

export const FAQS = [
  {
    q: "Was ist ein Hausnotruf und wie funktioniert er?",
    a: "Ein Hausnotruf ist ein Notrufsystem für zu Hause. Es besteht aus einer Basisstation mit Freisprecheinrichtung und einem kleinen, wasserdichten Sender als Armband oder Kette. Auf Knopfdruck wird sofort eine 24-Stunden-Notrufzentrale erreicht, die Hilfe organisiert.",
  },
  {
    q: "Für wen ist ein Hausnotruf sinnvoll?",
    a: "Der Hausnotruf ist ideal für ältere, kranke oder alleinlebende Menschen sowie für Personen mit erhöhtem Sturzrisiko. Auch Angehörige gewinnen Sicherheit, weil sie im Notfall sofort informiert werden.",
  },
  {
    q: "Was passiert, wenn ich nicht sprechen kann?",
    a: "Wenn Sie den Knopf drücken, sich aber nicht melden, geht die Notrufzentrale automatisch von einem Notfall aus und veranlasst umgehend Hilfe – zum Beispiel durch Angehörige oder den Rettungsdienst.",
  },
  {
    q: "Kann ich den Sender auch beim Duschen tragen?",
    a: "Ja. Der Funksender ist wasserdicht und kann rund um die Uhr getragen werden – auch unter der Dusche oder in der Küche, also genau dort, wo Stürze besonders häufig passieren.",
  },
  {
    q: "Wie schnell kommt im Notfall Hilfe?",
    a: "Der Alarm wird in Sekunden an die Notrufzentrale übermittelt. Die Zentrale nimmt sofort Kontakt auf und alarmiert je nach Situation Angehörige, Nachbarn oder den Rettungsdienst.",
  },
  {
    q: "Was kostet der Hausnotruf und übernimmt die Pflegekasse die Kosten?",
    a: "Bei einem anerkannten Pflegegrad kann die Pflegekasse einen Teil der Kosten für den Hausnotruf übernehmen. Wir beraten Sie gerne persönlich und unverbindlich zu Ihrer individuellen Situation – rufen Sie uns einfach an.",
  },
  {
    q: "Brauche ich einen Internetanschluss oder Festnetz?",
    a: "Nein, ein Internetanschluss ist nicht zwingend erforderlich. Wir prüfen bei der Beratung, welche Anschlussart bei Ihnen zu Hause vorhanden ist, und richten das System passend für Sie ein.",
  },
  {
    q: "Wie wird das Hausnotrufsystem installiert?",
    a: "Die Installation ist unkompliziert. Auf Wunsch übernehmen wir die professionelle Einrichtung bei Ihnen zu Hause und erklären Ihnen alles in Ruhe. Danach ist das System sofort einsatzbereit.",
  },
];
